import { useEffect, useState } from "react";
import { findEntityData } from "../api/apiService";
import icon from "../assets/a3.webp";

const WhyChoose = () => {
  const points = [
    "Specialized in Breakbulk, Project Cargo & RORO operations",
    "60+ Million Freight Tonnes handled across all major Indian ports",
    "15,000+ MAFI trailer moves with zero compromise on safety",
    "Global network of strategic partnerships with top vessel operators",
    "End-to-end services from port handling to customs clearance and delivery",
  ];

  const [section1, setSection1] = useState()
  const findData = async () => {
    const res = await findEntityData('sss_why_choose_us')
    setSection1(res?.data?.[0])
  }

  useEffect(() => {
    findData()
  }, [])
  return (
    <section className="container mx-auto pt-24 px-6 py-12 text-center">
      <h1 className="text-3xl font-bold text-[#F37934] mb-6" data-aos="zoom-in"
        data-aos-duration="800"
        data-aos-easing="ease-out">
        {section1?.heading}
      </h1>

      <p className="items-justify max-w-2xl mx-auto mb-10 whitespace-pre-line">
        {section1?.content}
      </p>

      <div className="space-y-4 max-w-4xl mx-auto">
        {section1?.data?.map((text, index) => (
          <div
            key={index}
            className="flex items-center text-left gap-4 p-4 rounded-xl border-2 border-white"
            style={{
              background: "linear-gradient(to bottom right, #F0F0E5, #FFFFFF, #F0F0E5)",
            }}
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-delay={index * 200}
          >
            <div className="flex items-center justify-center flex-shrink-0">
              <img src={icon} alt="icon" className="w-8 h-8 md:w-10 md:h-10" />
            </div>
            <p className="text-sm md:text-base">{text.content}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default WhyChoose;
